module.exports = __webpack_public_path__ + "static/img/dashboard.1a50462a.png";